
































































































































import Loading from 'vue-loading-overlay';
import { addItemsToListIfAreNotAdded, ColorsList, removeItemsFromList } from '../../core/utils';
import { JourneysService } from '../../journeys/api/JourneysService';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { phoneValidator } from '../../core/utils/validations';
import { MultipleSelect, MsgBox } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { Mounted } from '../../core/decorators';
import Axios from 'axios';
import { mask } from 'vue-the-mask';
import { SettingsService } from '../api/SettingsService';
import { NormsServices } from '../../norms/api/NormsServices';
import VariableClasification from '../models/VariableClasification';
import { formatDate } from '../../core/utils';
import Input from '../../core/components/Input.vue';
import VariableGroupAlert from './VariableGroupAlert.vue';
import moment from 'moment';
import { variableGroupDevicesInfo } from '../../norms/utils';

@Component({
    components: { Input, MultipleSelect, MsgBox, TableArrows, SimpleTable, Loading, VariableGroupAlert }
})
export default class AssignGroup extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    variableGroupList: any[] = [];
    selectedVariableGroups: any[] = [];
    pendingRequest: boolean = false;
    msgInfo: string = variableGroupDevicesInfo;
    skyColor: string = ColorsList.skyblue;
    description: string = '';

    searchVar: string = '';
    searchVarInGroup: string = '';

    availableSelectedVariables: Array<object> = [];
    availableVariablesSelected: Array<object> = [];
    searchavailableVariables: string = '';
    availableVehicles: Array<object> = [];
    loadingAvailableVariables: boolean = false;
    selectedVariables: Array<object> = [];
    configureVehicles: boolean = false;

    sortBy: string[] = ['name'];
    sortDesc: boolean[] = [false];

    get headersOfVariableGroup() {
        return [
            {
                text: 'Grupos de variables',
                value: 'description',
                sortable: true
            }
        ];
    }

    get headersSelectedVehicles() {
        return [
            {
                text: 'Vehículos',
                value: 'description',
                sortable: true
            }
        ];
    }

    async getVariableGroupList() {
        if (this.editing) {
            this.variableGroupList = this.getVariableGroupsForRemoveFromSelectedVehicles;
        } else {
            this.pendingRequest = true;
            NormsServices.getVariableGroupList()
                .then(data => {
                    this.variableGroupList = data.variablegroups;
                    this.pendingRequest = false;
                })
                .catch(err => {
                    this.$_errorPatchRecipients(err);
                    this.pendingRequest = false;
                });
        }
    }

    updateSelectedVariableGroups(rows){
        this.selectedVariableGroups = rows;
    }

    updateSearchValue(value){
        this.searchVar = value;
    }

    selectAllList() {
        this.selectedVariableGroups =
            this.selectedVariableGroups.toString() === this.variableGroupList.toString() ? [] : this.variableGroupList;
    }

    addAvailableVehicle() {
        this.selectedVariables = addItemsToListIfAreNotAdded(
            this.selectedVariables,
            this.availableVariablesSelected,
            'id'
        );
        this.availableVariablesSelected = [];
    }

    // @Watch('editing')
    // disableCompanyListenerOnVariableGroup() {
    //     this.$_disableListenkey();
    // }

    updateavailableVariablesSelected(rows) {
        this.availableVariablesSelected = rows;
    }

    excludeSelectedVariable(vehicle) {
        this.removeSelectedVehicle([vehicle]);
    }

    removeSelectedVehicle(itemsToExclude) {
        this.selectedVariables = removeItemsFromList(this.selectedVariables, itemsToExclude, 'id');
        this.availableSelectedVariables = [];
    }

    updateSelectedVariables(rows) {
        this.availableSelectedVariables = rows;
    }

    get isSowing() {
        return true;
    }

    get headersAvailableVariables() {
        return [
            {
                text: 'Variables',
                value: 'description',
                sortable: true
            }
        ];
    }

    @Prop() editing: boolean;
    @Prop() visible: boolean;
    @Prop() variableGroupToEdit: any;
    @Prop() selectedVehicles: any[];
    @Prop() getVariableGroupsForRemoveFromSelectedVehicles: any[];

    modalWidth: string = '750';
    optionsToSelect: any = [];
    preselectOptions: any = [];
    driverCompanies: any = [];
    showMultiSelect: boolean = false;
    dialogTagConfirmation: boolean = false;
    showForm: boolean = false;
    driverActive: boolean = false;
    formRequest: any = {
        end: null,
        msg: ''
    };
    nameRules: any = [v => !!v || 'Debe ingresar el nombre', v => (v && v.length >= 1) || 'Debe ingresar el nombre'];

    valid: boolean = false;
    menu: boolean = false;
    setMinDate: any = this.getTodayDateLessVal(100);
    setMaxDate: any = this.getTodayDateLessVal(16);
    cancelToken: any = null;

    phoneValidation: any = phoneValidator;

    directives: {
        mask;
    };

    // async getVariablesGroupById() {
    //     //Se pone la info en los campos
    //     const data = await NormsServices.getVariablesGroupById(this.alarmToEditId);
    //     this.alarmSelectedForEdition = data;
    //     this.basicAlarmToEdit = {
    //         filter_time: this.alarmSelectedForEdition.basic_alarm.filter_time,
    //         variable_classification_id: this.alarmSelectedForEdition.basic_alarm.variable_classification_id,
    //         max_value: this.alarmSelectedForEdition.basic_alarm.max_value,
    //         min_value: this.alarmSelectedForEdition.basic_alarm.min_value
    //     }

    //     this.alarmActiveSwitch = this.alarmSelectedForEdition.active;
    //     this.description = this.alarmSelectedForEdition.description;

    //     const selectedVehiclesInAlarm = this.getVehicles.filter((filteredVehicle) =>
    //         this.vehicleIsInArray(filteredVehicle, data.vehicles)
    //     );
    //     if(this.selectedVehicles.length == 0) {
    //         this.selectedVehicles.push(...selectedVehiclesInAlarm);
    //     }
    //     if (data.recipients && data.recipients.length) {
    //         data.recipients.forEach(this.updateRecipientData);
    //     }
    // }

    get getPreselectedOptions() {
        return this.preselectOptions;
    }

    get getUserCompanies() {
        return this.optionsToSelect;
    }

    mounted() {
        this.getVariableGroupList();
        // this.loadModalData();
    }

    // @Watch('visible')
    // loadModalData() {
    //     if (this.editing) {
    //         if (this.variableGroupToEdit !== null) {
    //             this.description = this.variableGroupToEdit.description;
    //             this.selectedVariables = this.variableGroupToEdit.variable_clasifications;
    //         } else {
    //             this.description = '';
    //             this.selectedVariables = [];
    //         }
    //     } else {
    //         this.description = '';
    //         this.selectedVariables = [];
    //     }
    // }

    @Watch('selectedVariableGroups')
    showGroupsSpanError() {
        if (this.selectedVariableGroups.length == 0) {
            return true;
        } else {
            return false;
        }
    }

    format(date: string) {
        return formatDate(date);
    }

    save(date) {
        let menuElement = this.$refs.menu as HTMLFormElement;
        menuElement.save(date);
    }

    closeDialogTag() {
        this.dialogTagConfirmation = false;
    }

    getCompaniesToEditFromList(companies) {
        let companiesToEdit: any = [];
        let allCompanies = this.$_getCompanies;
        let self = this;
        this.preselectOptions = [];
        for (let i = 0; i < companies.length; i++) {
            for (let b = 0; b < allCompanies.length; b++) {
                if (companies[i] == allCompanies[b].id) {
                    companiesToEdit.push(allCompanies[b]);
                    self.preselectOptions.push(allCompanies[b]);
                }
            }
        }
        this.preselectOptions = this.removeDuplicatedFromObject(this.preselectOptions);
        return companiesToEdit;
    }

    submitVariableGroup() {
        this.sendDataToParent();
        if (!this.editing) {
            this.$emit('submitVariableGroup');
        } else {
            this.$emit('submitRemoveVariableGroup');
        }
    }

    get canSaveVariableGroup() {
        return Boolean(this.selectedVariableGroups.length);
    }

    sendDataToParent() {
        let submitedData = {
            variable_group_list: this.selectedVariableGroups.map(variableGroup => variableGroup.id)
        };
        this.$emit('submit', submitedData);
    }

    getTodayDateLessVal(val) {
        let d = new Date();
        let year = d.getFullYear();
        let month = d.getMonth();
        let day = d.getDate();
        let c = new Date(year - val, month, day).toISOString().substr(0, 10);
        return c;
    }

    capitalizeFirstsLetterOfString(string) {
        return string.toLowerCase().replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
    }

    addResultMesage(end, msg) {
        this.formRequest = {
            end: end,
            msg: msg
        };
    }

    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });

        return uniqueObject;
    }

    get form(): Vue & { validate: () => boolean } {
        return this.$refs.form_driver as Vue & { validate: () => boolean };
    }

    getMinutesFromHoursAndMinutes(hours, minutes) {
        return parseInt(hours) * 60 + parseInt(minutes);
    }

    getHoursAndMinutesFromMinutes(mins) {
        let hours = Math.floor(mins / 60);
        let minutes = mins % 60;
        return {
            hours: hours.toString(),
            minutes: minutes.toString()
        };
    }

    @Emit()
    closeDialog(action: boolean, driver: any) {}
}
